module.exports = __webpack_public_path__ + "img/Z8.4678eb68.png";